import {
  CdkDragDrop,
  moveItemInArray
} from "@angular/cdk/drag-drop";
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  ViewChild
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import * as moment from "moment";
import { DataSharingService } from "src/app/AuthGuard/DataSharingService";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { LosService } from "src/app/_LOS/services/los.service";
import { LmsService } from "src/app/_Lms/services/lms.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
import { ReportsService } from "../services/reports.service";
// import * as XLSX from 'xlsx';
// import htmlToXlsx from 'html-to-xlsx';

@Component({
    selector: "app-resport-dump-data",
    templateUrl: "./resport-dump-data.component.html",
    styleUrls: ["./resport-dump-data.component.scss"],
    standalone: false
})
export class ResportDumpDataComponent implements OnInit, OnDestroy {
  currentUserId: any;
  DateSelected = new Date();
  showSpinner = false;
  selectedRow = -1;
  columns: any[] = [];
  columnshow = [];
  displayedColumns: string[] = [];
  AccountingCatDropdown: any[] = [];
  LoanAcCatId: any = "0";
  dataSource = new MatTableDataSource([]);
  // @ViewChild(MatSort) sort: MatSort;
  // @ViewChild("paginatorRef") paginator: MatPaginator;
  @ViewChild('tableContainer') tableContainer!: ElementRef;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  
  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  SelectSourceType: any = "";
  partnerDropdown: any;
  SalesExecutiveData: any;
  LeadSourceName: any;
  leadSourceDropdown: any;
  BranchesList: any = [];
  BranchId: any[] = [];
  branchDropdownSettings: any = {};
  productDropdownSettings: any = {};
  SelectedBranch: any = 0;
  productList: any[] = [];
  ProductId: any[] = [];
  selectedAction: any = "";
      LoanAccountCategory: any[] = [];
  catgegoryIdList: any = [];
    categoryDropdownSettings: any = {};

    pageSize = 1000;
  totalRecords = 0;
  currentPage = 0;
  batch: any[] = [];
  private dataCache = new Map<number, any[]>(); // pageNumber -> data[]

 ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
  constructor(
    private snackBar: MatSnackBar,
    private reportService: ReportsService,
    private changeDetection: ChangeDetectorRef,
    private dataSharingService: DataSharingService,
    private losService: LosService,
    private lmsService: LmsService,
    private _MasterService: MasterService
  ) {
    this.currentUserId = JSON.parse(
      sessionStorage.getItem("currentUser")
    ).userId;
    var k = localStorage.getItem("keys");
    if (k != null) {
      this.displayedColumns = JSON.parse(k).keys;
    }
  }
  ngOnDestroy(): void {
    localStorage.setItem(
      "keys",
      JSON.stringify({ keys: this.displayedColumns })
    );
  }

  ngOnInit() {
    this.dataSharingService.HeaderTitle.next("Master Component");
    this.dataSource.sort = this.sort;
    this.Get_PartnerForDropdown();
    this.getLeadSourceDropdown();
    this.GetSalesExecutive();
    this.getBranchesList();
    this.getProductList();
    this.initializeDropdownSettings();
    this.Get_Loan_Accounting_Category_ForDropdown();
  }

  selectHighligh(row) {
    this.selectedRow = row;
  }
  //   Get_Loan_Accounting_Category_ForDropdown() {
  //   this.lmsService.Get_Loan_Accounting_Category_ForDropdown({ ProductId: 0 }).subscribe((res: any) => {
  //     this.AccountingCatDropdown = res;
  //   })
  // }
  Get_Loan_Accounting_Category_ForDropdown() {
    this.lmsService
      .Get_Loan_Accounting_Category_ForDropdown({ ProductId: 0 })
      .subscribe((res: any) => {
        this.catgegoryIdList = res;
      });
  }
  onCategorySelectionChange() {
    this.catgegoryIdList = this.moveSelectedItemsToTop(
      this.catgegoryIdList,
      this.LoanAccountCategory,
      "Loan_CategoryId"
    );
   }
  //  getSelectedIds(items: any[], key: string): string {
  //   return items?.map((item) => item[key]).join(",") || "0";
  // }
  // initializeCategoryDropdownSettings() {
  //   this.categoryDropdownSettings = {
  //     singleSelection: false,
  //     idField: "Loan_CategoryId",
  //     textField: "Loan_category",
  //     selectAllText: "Select All",
  //     unSelectAllText: "Deselect All",
  //     allowSearchFilter: true,
  //     itemsShowLimit: 1,
  //     showSelectedItemsAtTop: true,
  //   };
  // }

  checkedChange(event) {
    var column = event.target.id;
    if (event.target.checked) {
      this.AddColumnToDisplay(column);
    } else {
      this.removeColumnFromDisplay(column);
    }
    console.log("sdfsdfsdf", event.target.checked);
    this.changeDetection.detectChanges();
  }

  onColumnDrop(event: CdkDragDrop<string[]>): void {
    const previousIndex = event.previousIndex;
    const currentIndex = event.currentIndex;
    console.log("event ", event);
    if (event.container.id == "DeleteContainer")
      this.removeColumnFromDisplay(event.item.data.name);

    if (event.item.dropContainer.id == "DeleteContainer") {
      var col = event.item.data.name;
      this.AddColumnToDisplayPosition(col, currentIndex);
    }

    moveItemInArray(this.displayedColumns, previousIndex, currentIndex);
  }

  removeColumnFromDisplay(str) {
    var ind = this.displayedColumns.indexOf(str);
    if (ind >= 0) this.displayedColumns.splice(ind, 1);
    if (!this.columnshow.includes(str)) this.columnshow.push(str);
  }

  AddColumnToDisplay(str) {
    if (!this.displayedColumns.includes(str)) this.displayedColumns.push(str);
    var ind = this.columnshow.indexOf(str);
    if (ind >= 0) this.columnshow.splice(ind, 1);
  }
  AddColumnToDisplayPosition(str, position) {
    if (!this.displayedColumns.includes(str))
      this.displayedColumns.splice(position, 0, str);

    var ind = this.columnshow.indexOf(str);
    if (ind >= 0) this.columnshow.splice(ind, 1);
  }

  //Get Requests

  // Get_Dump_Data() {
  //   this.showSpinner = true;
  //   this.reportService
  //     .Report_Dump_Data({
  //       Emp_Id: this.currentUserId,
  //       Date: moment(this.DateSelected).format("YYYY-MM-DD"),
  //       SourceType: this.SelectSourceType || "",
  //       SourceId: this.LeadSourceName || 0,
  //     })
  //     .subscribe(
  //       (result: any[]) => {
  //         if (result.length > 0) {
  //           this.dataSource = new MatTableDataSource(result);
  //           this.dataSource.paginator = this.paginator;
  //           this.columns = [];
  //           //get all keys
  //           var key = Object.keys(result[0]);
  //           // add to column variable
  //           this.displayedColumns = key;
  //           this.columnshow = [];
  //           key.forEach((x) => {
  //             this.columns.push({ field: x });
  //             if (!this.displayedColumns.includes(x)) {
  //               this.columnshow.push(x);
  //             }
  //           });
  //         } else {
  //           this.snackBar.openFromComponent(SnackbarComponent, {
  //             data: "No data found",
  //             ...this.configSuccess,
  //           });
  //           this.showSpinner = false;
  //           this.dataSource = null;
  //         }
  //         this.showSpinner = false;
  //       },
  //       () => {
  //         this.showSpinner = false;
  //       }
  //     );
  // }

  exportTableAsXLSX(): void {
    const uri = "data:application/vnd.ms-excel;base64,";
    const template =
      '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>';
    const base64 = (s: string): string =>
      window.btoa(unescape(encodeURIComponent(s)));
    const format = (s: string, c: { [key: string]: string }): string =>
      s.replace(/{(\w+)}/g, (m, p) => c[p]);

    const table = document.getElementById(
      "master_component"
    ) as HTMLTableElement;
    const worksheetName = "MASTER COMPONENT"; // Set the desired worksheet name here
    const ctx = { worksheet: worksheetName, table: table.innerHTML };
    const downloadLink = document.createElement("a");
    const fromDateStr = moment(this.DateSelected).format("DD-MM-YYYY");

    // Generate the data URI for the Excel file
    downloadLink.href = uri + base64(format(template, ctx));

    // Set the file name for the download
    downloadLink.download = `${worksheetName}_${fromDateStr}.xls`;

    // Trigger the download
    downloadLink.click();
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  getLeadSourceDropdown() {
    this.showSpinner = true;
    this.losService.getLeadSourceDropdown({}).subscribe((res: any) => {
      this.leadSourceDropdown = res;
      console.log("Lead Source Dropdown", this.leadSourceDropdown);
      this.showSpinner = false;
    });
  }

  Get_PartnerForDropdown() {
    console.log("Partner Dropdown API Function");

    if (
      this.SelectSourceType == "Agent" ||
      this.SelectSourceType == "DSA" ||
      this.SelectSourceType == "Dealer"
    ) {
      this.losService
        .Get_PartnerForDropdown({
          PartnerType: this.SelectSourceType,
          branchId: 0,
        })
        .subscribe((res: any) => {
          this.partnerDropdown = res;
        });
      this.LeadSourceName = 0;
    } else if (
      this.SelectSourceType == "Sales Executive" ||
      this.SelectSourceType == "Telecaller Executive" ||
      this.SelectSourceType == "Marketing Executive"
    ) {
      this.partnerDropdown = [];
      this.SalesExecutiveData.forEach((obj: any) => {
        this.partnerDropdown.push({
          PartnerId: obj.EmpId,
          Partner_Name: obj.EmpName,
        });
      });
      this.LeadSourceName = 0;
    } else {
      this.LeadSourceName = "";
    }
  }

  GetSalesExecutive() {
    this.losService
      .getEmployeeDropdown({
        BranchId: 0,
        ProcessId: 1,
        ProductId: 0,
      })
      .subscribe((res: any) => {
        // this.employeeDropdown = res;
        this.SalesExecutiveData = res;
        this.Get_PartnerForDropdown();
        //console.log('res', res);
      });
  }

  async loadDumpDataList() {
    const payload = {
       Emp_Id: this.currentUserId,
        Date: moment(this.DateSelected).format("YYYY-MM-DD"),
        SourceType: this.SelectSourceType || "",
        SourceId: this.LeadSourceName || 0,
        ProductId: this.getSelectedIds(this.ProductId, "ProductId"),
        BranchId: this.getSelectedIds(this.BranchId, "BranchId"),
        LoanAcCategory: this.LoanAccountCategory?.length > 0 ? this.getSelectedIds(this.LoanAccountCategory, "Loan_CategoryId") : "0",

    };
     this.loadDumpData(payload);
  }
  
  async loadDumpData(payload) {
  this.batch = [];
  this.dataSource.data = [];
  this.columns = [];
  this.displayedColumns = [];
  this.columnshow = [];
  this.totalRecords = 0;

  let isColumnsLoaded = false;

  await this.reportService.ReportDumpDataNew((row) => {
    // Load dynamic columns only once (on first row)
    if (!isColumnsLoaded) {
      const key = Object.keys(row);
      // this.displayedColumns = ["SrNo", ...key];
      this.displayedColumns = key;
      this.columns = key.map((x) => ({ field: x }));
      this.columnshow = key.filter((x) => !this.displayedColumns.includes(x));

      isColumnsLoaded = true;
    }

    // Push rows to batch
    this.batch.push(row);

    // Update table every 100 rows
    if (this.batch.length >= 100) {
      this.totalRecords = this.batch[0].TotalData;
      this.appendToTable(this.batch);
      this.batch = [];
      this.showSpinner = false;

      if (this.totalRecords <= 100) {
        this.showSpinner = false;
      }
    }
  }, payload);

  // Last chunk
  if (this.batch.length > 0) {
    //  this.totalRecords = this.batch[0].TotalData;
    this.appendToTable(this.batch);
  }
  this.showSpinner = false;
}

   appendToTable(rows: any[]) {
    this.dataSource.data = [...this.dataSource.data, ...rows];

    setTimeout(() => this.scrollToBottom(), 20);
    this.dataSource.paginator = this.paginator;
  }

  scrollToBottom() {
    if (!this.tableContainer) return;

    const el = this.tableContainer.nativeElement;
    el.scrollTop = el.scrollHeight;
  }

  onsearch(){
    this.showSpinner = true;
    this.currentPage = 0;
    this.dataCache.clear();
   
    this.loadDumpDataList();
  }

  handleAction() {
     if(this.selectedAction==""){
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Please select an action",
        ...this.configSuccess,
      });
    }
  else if (this.selectedAction === "view") {
    this.onsearch();
  } 
  else if (this.selectedAction === "export") {
    this.exportExcel();
  }

  // Optional: Reset dropdown back to default
  // this.selectedAction = "";
}
  exportExcel() {
    this.showSpinner = true;
    this.reportService.ExportReportDumpData({
      Emp_Id: this.currentUserId,
        Date: moment(this.DateSelected).format("YYYY-MM-DD"),
        SourceType: this.SelectSourceType || "",
        SourceId: this.LeadSourceName || 0,
        ProductId: this.getSelectedIds(this.ProductId, "ProductId"),
        BranchId: this.getSelectedIds(this.BranchId, "BranchId"),
        LoanAcCategory: this.LoanAccountCategory?.length > 0 ? this.getSelectedIds(this.LoanAccountCategory, "Loan_CategoryId") : "0",
    }).subscribe((blob: Blob) => {
      if (blob) {
        this.showSpinner = false;
        const a = document.createElement("a");
        const objectUrl = URL.createObjectURL(blob);
        a.href = objectUrl;
        const fromDateStr = moment(this.DateSelected).format("DD-MM-YYYY");
        a.download = `MasterReport_${fromDateStr}.xlsx`;
        a.click();
        URL.revokeObjectURL(objectUrl);
      }
    });}
  
  getBranchesList() {
    this.lmsService
      .GetBranches({ Emp_Id: this.currentUserId })
      .subscribe((result) => {
        this.BranchesList = JSON.parse(JSON.stringify(result));
        console.log(this.BranchesList);
      });
  }
   initializeDropdownSettings() {
    this.branchDropdownSettings = {
      singleSelection: false,
      idField: "BranchId",
      textField: "Branch_Name",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };

    this.productDropdownSettings = {
      singleSelection: false,
      idField: "ProductId",
      textField: "Product",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
    this.categoryDropdownSettings = {
      singleSelection: false,
      idField: "Loan_CategoryId",
      textField: "Loan_category",
      selectAllText: "Select All",
      unSelectAllText: "Deselect All",
      allowSearchFilter: true,
      itemsShowLimit: 1,
      showSelectedItemsAtTop: true,
    };
  }

    getSelectedIds(items: any[], key: string): string {
    return items?.map((item) => item[key]).join(",") || "0";
  }

  moveSelectedItemsToTop(items: any[], selectedItems: any[], key: string): any[] {
    if (!items?.length) return [];
    if (!selectedItems?.length) return items;

    const selectedIds = selectedItems.map((s) => s[key]);
    const selected = items.filter((i) => selectedIds.includes(i[key]));
    const rest = items.filter((i) => !selectedIds.includes(i[key]));
    return [...selected, ...rest];
  }

  onBranchSelectionChange() {
    this.BranchesList = this.moveSelectedItemsToTop(
      this.BranchesList,
      this.BranchId,
      "BranchId"
    );
  }
    onProductSelectionChange() {
    this.productList = this.moveSelectedItemsToTop(
      this.productList,
      this.ProductId,
      "ProductId"
    );
  }
    getProductList() {
    this._MasterService
      .GetProductList({ Emp_Id: this.currentUserId })
      .subscribe((ress) => {
        this.productList = JSON.parse(JSON.stringify(ress));
      });
  }
}
